import React from 'react'
import styles from '../uploader.styles.jcss'
import Icon from 'blocks.simple/icon/icon'

const FileItem = ({ file, deleteFile }: { file: File; deleteFile: (fileName: string) => void }) => {
    return (
        <div className={styles.fileItem}>
            <div className={styles.fileInfo}>
                <Icon type="paperClip" size={16} />
                <span className={styles.fileName}>{file.name}</span>
            </div>
            <Icon type="delete" size={16} className={styles.deleteIcon} onClick={() => deleteFile(file.name)} />
        </div>
    )
}

export default FileItem
